import { faClock, faMapMarkedAlt, faPercentage, faShippingFast } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from 'react';
import { Card, Col, Container, Row } from "react-bootstrap";

const shippingFast = <FontAwesomeIcon icon={faShippingFast} />;
const clock = <FontAwesomeIcon icon={faClock} />
const mapMarked = <FontAwesomeIcon icon={faMapMarkedAlt} />;
const percentage = <FontAwesomeIcon icon={faPercentage} />;

const WhyEatCake = () => {
    return (
        <div className="my-5">
            <Container>
                <h1 className="fw-bold text-dark text-center">Why Eat Cake</h1>

                <Row xs={1} sm={1} md={2} lg={4} xl={4} className="g-4 my-3">
                    <Col>
                        <Card className="text-center py-4 bg-light">
                            <span className="fs-1">{shippingFast}</span>
                            <Card.Body>
                                <Card.Title>Free Delivery</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-center py-4 bg-light">
                            <span className="fs-1">{clock}</span>
                            <Card.Body>
                                <Card.Title>Fastest Delivery</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-center py-4 bg-light">
                            <span className="fs-1">{mapMarked}</span>
                            <Card.Body>
                                <Card.Title>Delivery Anywhere</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-center py-4 bg-light">
                            <span className="fs-1">{percentage}</span>
                            <Card.Body>
                                <Card.Title>Exiting Discounts</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default WhyEatCake;